module.exports = __webpack_public_path__ + "media/5_2.469572aa.wav";